import React from "react";
import Button from "../../lib/ui/components/button/Button";
import Tabs from "../../lib/ui/components/tabs/Tabs";

export default function ({
  handleDiscard,
  handleSave,
  hasChanges = false,
  canSave,
  isSaving = false,
}) {
  return (
    <div className="flex w-full mb-6 justify-between items-start">
      <div className="flex-1">
        <Tabs
          ariaLabel="Settings tabs"
          variant="underline"
        >
          <Tabs.Item title="User Settings" to="/settings/profile" />
          <Tabs.Item title="Admin Settings" to="/settings/company" />
        </Tabs>
      </div>
      <div className="flex space-x-4 ml-auto">
        <Button
          variant="secondary"
          onClick={handleDiscard}
          disabled={!hasChanges || isSaving}
        >
          Discard Changes
        </Button>
        <Button 
          variant="primary"
          onClick={handleSave}
          disabled={!(canSave ?? hasChanges) || isSaving}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </div>
    </div>
  );
}
